import React, { useContext, useMemo, useState } from 'react';
import { CheckoutContext } from '../../Providers/CheckoutContext';
import { usePathname } from '../../../navigation';

type Props = {
  onClick: () => void;
  title?: string;
  className: string;
  bgColor: string;
  textColor: string;
};

const PlaceOrderButton: React.FC<Props> = ({
  onClick,
  title = 'Start your Order',
  className,
  bgColor,
  textColor,
}) => {
  const currentCheckout = useContext(CheckoutContext);
  const pathname = usePathname();
  const regex = /^\/feed\/restaurants\/[^/]+\/order\/[^/]+$/;
  const [useConfig, setUseConfig] = useState(false);
  useMemo(() => {
    setUseConfig(regex.test(pathname));
  }, [pathname]);

  return (
    <>
      <div className={`p-4 w-full justify-center items-center ${className}`}>
        <button
          className={`${bgColor} ${textColor} align-middle justify-center font-bold text-lg shadow-lg rounded-full w-full h-10 outline-none focus:outline-none`}
          onClick={onClick}
        >
          {useConfig ? title : currentCheckout?.checkout_btn_title ?? title}
        </button>
      </div>
    </>
  );
};

export default PlaceOrderButton;
